import {ReactComponent as People} from '../assets/images/people.svg';
export const PeopleIcon = People;
